import React, { useEffect, useState } from "react";
import { DownloadSimple } from "@phosphor-icons/react";
import { useLang } from "../lib/i18n";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallApp = ({ variant = "footer" }) => {
  const { lang } = useLang();
  const [prompt, setPrompt] = useState(null);
  const [showTip, setShowTip] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;
  if (!prompt && !isIOS()) return null;

  const onClick = async () => {
    if (prompt) {
      prompt.prompt();
      await prompt.userChoice;
      setPrompt(null);
    } else if (isIOS() && !localStorage.getItem("px_ios_install_tip")) {
      localStorage.setItem("px_ios_install_tip", "1");
      setShowTip(true);
      setTimeout(() => setShowTip(false), 6000);
    } else {
      setShowTip(true);
      setTimeout(() => setShowTip(false), 6000);
    }
  };

  const label = lang === "hi" ? "ऐप इंस्टॉल करें" : "Install App";
  const tip = lang === "hi" ? "Share → Add to Home Screen पर टैप करें" : "Tap Share → Add to Home Screen";

  const cls =
    variant === "menu"
      ? "mt-1 flex items-center justify-center gap-2 rounded-full border border-electric/40 px-5 py-3 text-center font-bold text-electric"
      : "inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-xs font-bold text-slate-300 transition-all hover:-translate-y-0.5 hover:border-electric hover:text-electric";

  return (
    <span className="relative inline-block">
      <button type="button" onClick={onClick} className={cls} data-testid={`install-app-${variant}`}>
        <DownloadSimple size={16} weight="bold" /> {label}
      </button>
      {showTip && (
        <span className="absolute bottom-full left-1/2 z-50 mb-2 w-56 -translate-x-1/2 rounded-xl bg-navy px-4 py-3 text-center text-xs font-semibold text-white shadow-xl" data-testid="ios-install-tip">
          {tip}
        </span>
      )}
    </span>
  );
};
